import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../../../components/elements/table/Table";
import { setTitle } from "../../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../../helpers";
import { useDebounce } from "../../../../../hooks/useDebounce";
import LimitSelect from "../../../../../components/elements/LimitSelect";
import Badge from "../../../../../components/elements/Badge";
import Search from "../../../../../components/form/Search";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { cryptoList, cryptoStatusChange } from "../../../../../services/cryptoService";
import { classNames } from "../../../../../helpers/classNames";
import ActionBar from "../../../../../components/elements/ActionBar";
import { status_filter,featured_filter } from "../../../../../components/constant/constant";

const CryptoCurrencyList = () => {
  setTitle("Crypto Currency");
  //   const { t } = useTranslation();
  //   const { session, loginData } = useSelector((state) => state?.authProvider);
  const queryClient = useQueryClient();
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "createdAt",
  });

  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectFilterItem, setSelectFilterItem] = useState();

  const { data, isFetching, isLoading, error } = useQuery({
    queryKey: ["crypto-currency", filters, search, selectFilterItem],
    queryFn: async () => {
      const queryParams = {
        ...filters,
        ...(selectedFilter === "status" && { status: selectFilterItem?.value }),
        ...(selectedFilter === "featured" && { isFeatured: selectFilterItem?.value }),
        ...(search && { keyword: search }),
      };

      const res = await cryptoList(queryParams);
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs || {};
    },
  });

  const options = [
    {
      id: "enquiryDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "Enquiry Delete",
    },
  ];

  // const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
  //   mutationFn: async ({ id, status }) => {
  //     queryClient.setQueryData(["crypto-currency", filters, search], (state) => {
  //       if (!state) return;

  //       const updatedData = state?.data?.map((item) =>
  //         item?._id === id
  //           ? {
  //               ...item,
  //               status: item.status === "active" ? "inactive" : "active",
  //             }
  //           : item
  //       );

  //       return { ...state, data: updatedData };
  //     });
  //     const res = await cryptoStatusChange({ ids: [id], status });

  //     return { res, payload: { id, status } };
  //   },

  //   onSuccess: ({ res, payload }) => {
  //     if (res?.status === 200) {
  //       toast.success("Cryptocurrency status changed successfully.");
  //     } else {
  //       queryClient.setQueryData(["crypto-currency", filters, search,selectFilterItem], (state) => {
  //         if (!state) return;

  //         const revertedData = state?.data?.map((item) =>
  //           item?._id === payload.id
  //             ? {
  //                 ...item,
  //                 status: item.status === "active" ? "inactive" : "active",
  //               }
  //             : item
  //         );

  //         return { ...state, data: revertedData };
  //       });

  //       toast.error(res?.message || "Failed to update status.");
  //     }
  //   },

  //   onError: (error) => {
  //     toast.error(error?.message || "Something went wrong while updating status.");
  //     console.error("Status update error:", error);
  //   },
  // });

  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
      mutationFn: async ({ id, status }) => {
        queryClient.setQueryData(["crypto-currency", filters, search, selectFilterItem], (state) => {
          if (!state) return;
  
          const updatedData = state?.data?.map((item) =>
            item?._id === id
              ? {
                  ...item,
                  status: item.status === "active" ? "inactive" : "active",
                }
              : item
          );
  
          return { ...state, data: updatedData };
        });
        const res = await cryptoStatusChange({ ids: [id], status });
  
        return { res, payload: { id, status } };
      },
  
      onSuccess: ({ res, payload }) => {
        if (res?.status === 200) {
          toast.success("Cryptocurrency status changed successfully.");
        } else {
          queryClient.setQueryData(["crypto-currency", filters, search, selectFilterItem], (state) => {
            if (!state) return;
  
            const revertedData = state?.data?.map((item) =>
              item?._id === payload.id
                ? {
                    ...item,
                    status: item.status === "active" ? "inactive" : "active",
                  }
                : item
            );
  
            return { ...state, data: revertedData };
          });
  
          toast.error(res?.message || "Failed to update status.");
        }
      },
  
      onError: (error) => {
        toast.error(error?.message || "Something went wrong while updating status.");
        console.error("Status update error:", error);
      },
    });
  const { mutate: featuredChangeHandler, isPending: featuredChangeInPending } = useMutation({
    mutationFn: async ({ id, isFeatured }) => {
      queryClient.setQueryData(["crypto-currency", filters, search, selectFilterItem], (state) => {
        if (!state) return;

        const updatedData = state?.data?.map((item) =>
          item?._id === id
            ? {
                ...item,
                isFeatured: item?.isFeatured === false ? true : false,
              }
            : item
        );

        return { ...state, data: updatedData };
      });
      const res = await cryptoStatusChange({ ids: [id], isFeatured });

      return { res, payload: { id, isFeatured } };
    },

    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        toast.success("Cryptocurrency status changed successfully.");
      } else {
        queryClient.setQueryData(["crypto-currency", filters, search, selectFilterItem], (state) => {
          if (!state) return;

          const revertedData = state?.data?.map((item) =>
            item?._id === payload.id
              ? {
                  ...item,
                  isFeatured: item?.isFeatured === false ? true : false,
                }
              : item
          );

          return { ...state, data: revertedData };
        });

        toast.error(res?.message || "Failed to update status.");
      }
    },

    onError: (error) => {
      toast.error(error?.message || "Something went wrong while updating status.");
      console.error("Status update error:", error);
    },
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Currency Name",
      align: "left",
      isSort: true,
      onSort: (val) => {
        if (val === "DESC") {
          setFilters((pre) => ({ ...pre, sortQuery: "-symbol" }));
        } else {
          setFilters((pre) => ({ ...pre, sortQuery: "symbol" }));
        }
      },
    },
    {
      _id: 2,
      name: "Current Price ($)",
      align: "left",
      isSort: true,
      onSort: (val) => {
        if (val === "DESC") {
          setFilters((pre) => ({ ...pre, sortQuery: "-price" }));
        } else {
          setFilters((pre) => ({ ...pre, sortQuery: "price" }));
        }
      },
    },
    {
      _id: 3,
      name: "Change (%)",
      align: "left",
    },
    {
      _id: 3,
      name: "Growth",
      align: "left",
    },
    {
      _id: 4,
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0 && val?.length === 1) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: status_filter || [],
    },
    {
          _id: 5,
          name: "Featured",
          align: "left",
          isFilter: true,
          isFilterSearch: false,
          onFilter: (val) => {
            if (val?.length > 0 && val?.length === 1) {
              setFilters((pre) => ({
                ...pre,
                isFeatured: val?.map((item) => item?.value),
                page: 1,
              }));
            } else {
              setFilters((pre) => {
                delete pre?.isFeatured;
                return { ...pre };
              });
            }
          },
          filterData: featured_filter || [],
        },
  ];
  // Table Body Data =====================>
  const tableData = data?.data
    ?.filter((i) => i?.symbol.endsWith("USDT"))
    .map((item) => {
      return {
        _id: item?.symbol,
        rowData: [
          {
            _id: 1,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data: item?.symbol.replace("USDT", "") || "-",
          },
          {
            _id: 2,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data: `$ ${parseFloat(item?.price).toFixed(2)}` || "-",
          },
          {
            _id: 4,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data: item?.changePercent || "-",
            data: `${item?.changePercent >= 0 ? "+" : ""}${item?.changePercent}` || "-",
          },
          {
            _id: 3,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data:
              <i className={`fas fa-arrow-trend-${item?.changePercent < 0 ? "down" : "up"} text-${item?.changePercent < 0 ? "red" : "green"}-600`}></i> ||
              "-",
          },
          {
            _id: 5,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data: (
              <div
                className="flex gap-2 items-center cursor-pointer"
                onClick={() => {
                  statusChangeHandler({
                    id: item?._id,
                    status: item?.status === "active" ? "inactive" : "active",
                  });
                }}
              >
                <Badge type={item?.status === "active" ? "success" : "danger"} label={item?.status === "active" ? "Active" : "Inactive"} />
              </div>
            ),
          },
          {
            _id: 5,
            type: "text",
            align: "left",
            cellClass: "!min-w-[100px]",
            data: (
              <div
                className="flex gap-2 items-center cursor-pointer"
                onClick={() => {
                  featuredChangeHandler({
                    id: item?._id,
                    isFeatured: item?.isFeatured === false ? true : false,
                  });
                }}
              >
                <Badge type={item?.isFeatured === true ? "info" : "warning"} label={item?.isFeatured === true ? "Yes" : "No"} />
              </div>
            ),
          },
        ],
      };
    });

  function actionHandler(val) {
    switch (val) {
      case "enquiryDelete":
        // setDeleteModal({
        //   isOpen: true,
        //   data: { _id: selectedItems },
        // });
        break;

      default:
        break;
    }
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-lg xl:text-3xl text-primary">{"Cryptocurrency List"}</div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          {selectedItems?.length > 0 && (
            <div className="flex items-center gap-2">
              <ActionBar options={options} onChange={actionHandler} />
              <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                {selectedItems?.length} Selected
                <button onClick={() => setSelectedItems([])} type="button" className="cursor-pointer">
                  <i className="fa-fw fa-light fa-xmark"></i>
                </button>
              </span>
            </div>
          )}
        </div>
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          handleOrdering={(val) => {
            console.log(val);
          }}
          isFetching={isFetching}
          isOrderingDisabled={true}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer={"!w-48"}
          // selectable
        />
      </div>
    </div>
  );
};

export default CryptoCurrencyList;
